var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { alpha } from '@mui/material/styles';
import { alertClasses } from '@mui/material/Alert';
// ----------------------------------------------------------------------
var COLORS = ['info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function alert(theme) {
    var lightMode = theme.palette.mode === 'light';
    var rootStyles = function (ownerState) {
        var standardVariant = ownerState.variant === 'standard';
        var filledVariant = ownerState.variant === 'filled';
        var outlinedVariant = ownerState.variant === 'outlined';
        var colorStyle = COLORS.map(function (color) {
            var _a, _b;
            return (__assign({}, (ownerState.severity === color && __assign(__assign(__assign({ borderRadius: 16 }, (standardVariant && (_a = {
                    color: theme.palette[color][lightMode ? 'darker' : 'lighter'],
                    backgroundColor: theme.palette[color][lightMode ? 'lighter' : 'darker']
                },
                _a["& .".concat(alertClasses.icon)] = {
                    color: theme.palette[color][lightMode ? 'main' : 'light']
                },
                _a))), (filledVariant && {
                color: theme.palette[color].contrastText,
                backgroundColor: theme.palette[color].main
            })), (outlinedVariant && (_b = {
                    backgroundColor: alpha(theme.palette[color].main, 0.08),
                    color: theme.palette[color][lightMode ? 'dark' : 'light'],
                    border: "solid 1px ".concat(alpha(theme.palette[color].main, 0.16))
                },
                _b["& .".concat(alertClasses.icon)] = {
                    color: theme.palette[color].main
                },
                _b))))));
        });
        return __spreadArray([], __read(colorStyle), false);
    };
    return {
        MuiAlert: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                },
                icon: {
                    opacity: 1
                },
                message: {
                    fontWeight: 400
                }
            }
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    marginBottom: theme.spacing(0.5),
                    fontWeight: theme.typography.fontWeightSemiBold
                }
            }
        }
    };
}
